import React from 'react';
import Navbar from '../../components/Layouts/Navbar';
import Footer from '../../components/Layouts/Footer';
import MetabaseHeader from '../../components/BusinessAnalytics/Metabase/MetabaseHeader';
import SubscribeStyleOne from '../../components/Common/SubscribeStyleOne';
import PageSeo from '../../components/Common/PageSeo';
import MetabaseFAQ from '../../components/BusinessAnalytics/Metabase/MetabaseFAQ';
import MetabaseWeitereServices from '../../components/BusinessAnalytics/Metabase/MetabaseWeitereServices';
import MetabaseText from '../../components/BusinessAnalytics/Metabase/MetabaseText';
import MetabaseVerständnisundErfahrungfürIhreBranche from '../../components/BusinessAnalytics/Metabase/MetabaseVerständnisundErfahrungfürIhreBranche';
import MetabaseCTA from '../../components/BusinessAnalytics/Metabase/MetabaseCTA';
import { useTranslations } from '../../locales/useTranslations';
import { useRouter } from 'next/router';

const Metabase = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('metabase_seo_title')}
                description={t('metabase_seo_description')}
                canonical={`${baseUrl}/business-analytics/metabase/`}
                openGraph={{
                    url: `${baseUrl}/business-analytics/metabase/`,
                    title: t('metabase_seo_title'),
                    description: t('metabase_seo_description'),
                    images: [
                        {
                            url: `${baseUrl}/images/logoog.png`,
                            width: 1200,
                            height: 630,
                            alt: t('metabase_seo_ogImageAlt1'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('metabase_seo_title'),
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('metabase_seo_keywords')
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: `https://simplify-data.de/business-analytics/metabase/`
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: `https://simplify-data.com/business-analytics/metabase/`
                    }
                ]}
            />



            <Navbar />
            <MetabaseHeader />
            <MetabaseVerständnisundErfahrungfürIhreBranche />
            <MetabaseText />
            <MetabaseCTA />
            <MetabaseFAQ />
            <MetabaseWeitereServices />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default Metabase;